<template>
    <div class="easter-egg" v-if="show">
        <div class="egg" v-if="showEgg">
            <div class="egg_img" :class="{'egg_animation': showEgg1}"></div>
            <div class="egg_btn" @click="handleClick"></div>
        </div>
        <div class="cash" v-if="showCash">
            <div class="cash_text">{{eggObj.cash || 0}}元现金红包</div>
            <div class="cash_btn" @click="show = false"></div>
            <div class="cash_bottom">请在“我的-服务-待提现”中查看奖励</div>
            <div class="cash_close" @click="show = false"></div>
        </div>
        
        <div class="coupon " :class="{'coupon_1': list.length == 1}" v-if="showCoupon">
            <div class="coupon_text">
                <div class="coupon_item" v-for="(item, index) in list" :key="index">
                    <div class="item_lf">
                        <div>¥<span>{{item.deductionMoney || 0}}</span></div>
                        <div>{{ item.isThreshold == 0 ? '无门槛' :'满' + item.useMinMoney + '元可用' }}</div>
                    </div>
                    <div class="item_rt">
                        <div>{{item.couponName}}</div>
                        <div>{{item.memo}}</div>
                    </div>
                </div>
            </div>
            
            <div class="cash_btn" @click="show = false"></div>
            <div class="cash_bottom">请在“小壶优选-我的-优惠券”中查看奖励</div>
            <div class="cash_close" @click="show = false"></div>
        </div>
    </div>
</template>
<script setup>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { showToast } from 'vant';
// import {  } from '@/api/youthBlindBox';
import { extractPrize } from '../api'
const route = useRoute();
const cityCode = ref(route.query.cityCode || '');
const latitude = ref(route.query.latitude || '');
const longitude = ref(route.query.longitude || '');

const emit = defineEmits([]);
const props = defineProps({
    boxId: {
        type: String,
        default: ''
    },
    boxType: {
        type: String,
        default: '1'
    }
})
const show = ref(false);// 是否显示彩蛋
const eggObj = ref({}); // 彩蛋列表
const list = ref([]); // 优惠券列表
const getEgg = () => {
    // 这里可以调用接口获取泡泡彩蛋信息
    // 假设接口返回的数据决定是否显示泡泡彩蛋
    // show.value = true; // 根据接口结果设置是否显示
    let data = {boxId: props.boxId, receiveSource: props.boxType,longitude: longitude.value,latitude: latitude.value, cityCode: cityCode.value};
    extractPrize(data).then(res => {
        if (res.code == 1) {
            show.value = true; // 隐藏泡泡彩蛋
            eggObj.value = res.data;
            list.value = res.data.packetDetailList || [];
        } else {
            // showToast(res.msg);
        }
    })
}
// 开启泡泡彩蛋

const showEgg = ref(true); // 是否显示泡泡彩蛋 
const showEgg1 = ref(false); // 是否显示泡泡彩蛋动画

const showCash = ref(false); // 是否显示现金红包
const showCoupon = ref(false); // 是否显示优惠券
const handleClick = () => {
    console.log('开启泡泡彩蛋');
    // animation: around1 1.5s linear infinite;
    // egg.value.css.animation = 'zoomIn 1.5s linear infinite';
    showEgg1.value = true
    setTimeout(() => {
        showEgg.value = false;
        showEgg1.value = false;
        if (eggObj.value.packetType == 1) {
            showCash.value = true;
        } else{
            showCoupon.value = true;
        }
    }, 1000);
}
onMounted(() => {
    if (!sessionStorage.getItem('appleTree')) {
        getEgg()
    } else {
        sessionStorage.removeItem('appleTree');
    }
})
</script>
<style lang="less" scoped>
.easter-egg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    background: #00000087;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    .egg, .cash, .coupon {
        width: 304px;
        height: 388px;
        background: url(../../../../assets/blindBox/easterEgg.png) no-repeat 0 0;
        background-size: 100% 100%;
        position: relative;
        margin: auto;
        
    }
    .egg_img {
        width: 156px;
        height: 185px;
        background: url(../../../../assets/blindBox/egg.png) no-repeat 0 0;
        background-size: 100% 100%;
        margin: 114px auto 0;
    }
    .egg_animation {
        animation: shake 1.5s linear infinite;
    }
    .egg_btn {
        position: absolute;
        bottom: 12px;
        left: 50%;
        transform: translate(-50%, 0);
        width: 180px;
        height: 52px;
    }
    .cash {
        width: 100vw;
        height: 474px;
        background: url(../../../../assets/blindBox/cash.webp) no-repeat 0 0;
        background-size: 100% 100%;
        animation: fade .8s ease-in-out;
    }
    .cash_text {
        text-align: center;
        margin-top: 145px;
        font-weight: 600;
        font-size: 20px;
        color: #FD3533;
    }
    .cash_btn {
        position: absolute;
        bottom: 100px;
        left: 50%;
        transform: translate(-50%, 0);
        width: 140px;
        height: 48px;
        background: url(../../../../assets/blindBox/accept.png) no-repeat 0 0;
        background-size: 100% 100%;
    }
    .cash_bottom {
        position: absolute;
        bottom: 75px;
        text-align: center;
        font-weight: 400;
        font-size: 12px;
        color: #767783;
        left: 50%;
        transform: translate(-50%, 0);
        width: 100vw;
    }
    .cash_close {
        width: 20px;
        height: 20px;
        background: url(../../../../assets/blindBox/close.png) no-repeat 0 0;
        background-size: 100% 100%;
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translate(-50%, 0);
    }
    .coupon {
        width: 100vw;
        height: 479px;
        background: url(../../../../assets/blindBox/coupon.webp) no-repeat 0 0;
        background-size: 100% 100%;
        animation: fade  .8s linear;
        .coupon_text {
            width: 224px;
            max-height: 192px;
            overflow: auto;
            position: absolute;
            top: 121px;
            left: 50%;
            transform: translate(-50%, 0);
        }
        .coupon_item {
            height: 80px;
            background: url(../../../../assets/blindBox/coupon_item.png) no-repeat 0 0;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 10px;
            font-family: PingFangSC-Regular;
            .item_lf {
                width: 88px;
                text-align: center;
                color: #FF8086;
                >div:first-child {
                    color: #FF4951;
                    span {
                        color: #ff4951;
                        font-size: 20px;
                        font-weight: 700;
                    }
                }
            }
            .item_rt {
                width: 103px;
                padding: 0 16px;
                >div:first-child {
                    width: 103px;
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 14px;
                    color: #1D1D2C;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                >div:last-child {
                    margin-top: 4px;
                    width: 103px;
                    color: #A2A4AE;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }
    .coupon_1 {
        width: 100vw;
        height: 412px;
        background: url(../../../../assets/blindBox/coupon_bg1.webp) no-repeat 0 0;
        background-size: 100% 100%;
        .coupon_text {
            top: 160px;
        }
    }
}
@keyframes shake {
    0%,
    to {
        transform: rotate(0deg);
    }

    10%,
    30%,
    50%,
    70%,
    90% {
        transform: rotate(15deg);
    }

    20%,
    40%,
    60%,
    80% {
        transform: rotate(-15deg);
    }
}
@keyframes fade {
    0%{
        transform: scale(.1);
    }
    100%{
        transform: scale(1);
    }
}
</style>